<template>
  <div id="operation">
    <!-- 操作记录 -->
    <div class="line" v-for="(item, index) in data" :key="index">
      <div class="top">
        <div class="tt">{{ item.operator }}</div>
        <div class="time">{{ item.time }}</div>
      </div>
      <div class="content">
        {{ item.content }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "div_dialog_operation",
  props: {
    list: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      data: this.list,
    };
  },
};
</script>

<style lang="less" scoped>
#operation {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  box-sizing: border-box;
  > .line {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    padding-bottom: 15px;
    border-bottom: @cut-off-rule;
    box-sizing: border-box;
    > .top {
      width: 100%;
      height: 35px;
      display: flex;
      align-items: center;
      > .tt {
        width: auto;
        margin-right: 9px;
        font-size: 15px;
        font-weight: bolder;
      }
      > .time {
        width: auto;
        font-size: 13px;
        color: #adadad;
      }
    }
    > .content {
      width: 100%;
      height: auto;
      font-size: 15px;
      margin-left: 6px;
      margin-top: 2px;
      text-align: left;
    }
  }
}
</style>